import { addDays } from 'date-fns'
import { Linking, Platform } from 'react-native'
// TODO : règle de gestion pour savoir si un user à des actions à réaliser sur un site
/*  Dans les specs :
    - réalisation d'une checklist
    OU
    - réalisation d'une EDL
    OU
    - réalisation d'un CQ
*/
const getNextActionOnSiteDate = (user: UserResponse, site: SiteResponse): Date | undefined => addDays(new Date(), 1)

// TODO : règle de gestion pour savoir si un user à des actions à réaliser sur une manifestation
/*  Dans les specs :
    - réalisation d'une checklist
    OU
    - réalisation d'une EDL
    OU
    - réalisation d'un CQ
*/
const getNextActionOnManifestationDate = (user: UserResponse, manifestation: ManifestationResponse): Date | undefined =>
  addDays(new Date(), 1)

const getNextActionOnSiteNumber = (site: SiteResponse): number => 3

const callPhoneNumber = (phoneNumber: string) =>
  Linking.openURL(`${Platform.OS === 'ios' ? 'telprompt:' : 'tel:'}${phoneNumber}`)

export { getNextActionOnSiteDate, getNextActionOnSiteNumber, getNextActionOnManifestationDate, callPhoneNumber }
